var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.874,
    height: 111,
    viewBox: "0 0 97.874 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #264de4;\n      }\n\n      .cls-2 {\n        fill: #2965f1;\n      }\n\n      .cls-3 {\n        fill: #ebebeb;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    className: "cls-1",
    d: "M0,0,8.907,99.9,48.877,111,88.957,99.89,97.874,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    className: "cls-2",
    d: "M67.456,91.213l7.619-85.36H35.069v94.338Z",
    transform: "translate(13.868 2.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    className: "cls-3",
    d: "M14.633,32.407l1.1,12.252H43.15V32.407Z",
    transform: "translate(5.787 12.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    className: "cls-3",
    d: "M43.776,14.634H13.052l1.114,12.253h29.61Z",
    transform: "translate(5.161 5.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    className: "cls-3",
    d: "M42.684,71.768V59.021l-.053.014L28.985,55.349l-.874-9.772h-12.3l1.716,19.239,25.1,6.967Z",
    transform: "translate(6.253 18.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    className: "cls-4",
    d: "M50.127,51.687,48.7,67.578,35.039,71.267V84.014l25.118-6.962.184-2.069,2.88-32.259.3-3.289,2.212-24.8H35.039V26.887H52.3L51.188,39.435H35.039V51.687Z",
    transform: "translate(13.856 5.787)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.9253cc725f2d9e440d673194a466cc58.svg";
export { ForwardRef as ReactComponent };